import { useContext } from 'react';
import { AppContext } from '../App';
import { AppContext as MainAppContext } from '../../App';
import { GameContext } from '../boards/LastcardBoard';
import logo_wide from '../assets/logo_wide.png';
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
} from 'react-icons/bs'


export default function CardDeclare(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);
  const gameContext = useContext(GameContext);

  function clicked(e) {
    e.stopPropagation();
  }

  if(gameContext.showCardDeclare) {
    if(gameContext.pendingCardDeclaration) {
      //...
      return (
        <div className='CorePaper coreShadow' onClick={clicked}>
          <div className='text-center'>
            <h5 style={{ fontSize: "20px" }}>
              Declare Card(s)<br/>
              <span className='font-semi-bold text-muted' style={{ fontSize: "15px" }}>Lia Kadi</span>
            </h5>

            <div
              style={{
                width: "100%",
              }}
              className='text-start'
            >
              <h6 className='core-text-goldish font-regular' style={{ fontSize: "14px", marginTop: "20px" }}>
                {
                  (gameContext.pendingCardDeclaration.type === 'chimba') ?
                  <>Declare Pick-up Card <span className='text-muted'>(Kadi ya kuchimba)</span>?</>:""
                }

                {
                  (gameContext.pendingCardDeclaration.type === 'special') ?
                  <>Declare {gameContext.pendingCardDeclaration.cards.length} Special Card(s)?</>:""
                }

                {
                  (gameContext.pendingCardDeclaration.type === 'normal') ?
                  <>Declare {gameContext.pendingCardDeclaration.cards.length} Card(s)?</>:""
                }
              </h6>
            </div>


            <div className='row' style={{ marginTop: "30px" }}>
              
              <div className='col-6 text-start'>
                <button
                className='btn'
                style={{
                  background: "var(--core-blackish)",
                  color: "var(--core-whitish)",
                }}
                onClick={() => gameContext.setShowCardDeclare(false)}
                >
                  No
                </button>
              </div>

              <div className='col-6 text-end'>
                <button
                className='btn'
                style={{
                  background: "var(--core-blackish)",
                  color: "var(--core-whitish)",
                }}
                onClick={() => {
                  gameContext.setShowCardDeclare(false)
                  gameContext.setCardDeclaration(gameContext.pendingCardDeclaration)
                }}
                >
                  Yes
                </button>
              </div>

            </div>
          </div>
        </div>
      )
      //...
    } else if(gameContext.rambaCardDeclaration) {
      //..reserver for card declare after ramba
    }
    
  }
}